import { motion, useReducedMotion } from 'framer-motion';
import { availableFeatures, plannedFeatures } from '@/config/features';
import { Reveal, Stagger, StaggerItem } from '../motion/Reveal';
import { SectionHeading } from '../ui/SectionHeading';

export function FeaturesSection() {
  const reduce = useReducedMotion();

  return (
    <section id="features" className="section-pad" aria-labelledby="features-heading">
      <div className="content-width">
        <SectionHeading
          eyebrow="Capabilities"
          title="Built for the pressure of a live accuracy meet."
          id="features-heading"
          description="Everything listed as available ships in AeroJudge today. Upcoming items are labeled clearly — we do not market unfinished work as ready."
        />

        <Stagger as="ul" className="mt-6 grid gap-2 sm:grid-cols-2 lg:grid-cols-4" stagger={0.03}>
          {availableFeatures.map((feature) => (
            <StaggerItem key={feature.id} as="li">
              <motion.div
                className="h-full rounded-lg border border-border bg-white px-3.5 py-3 shadow-sm"
                whileHover={reduce ? undefined : { y: -3 }}
              >
                <p className="font-semibold text-navy">{feature.name}</p>
                <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">{feature.description}</p>
              </motion.div>
            </StaggerItem>
          ))}
        </Stagger>

        {plannedFeatures.length > 0 ? (
          <Reveal className="mt-6" y={16}>
            <div className="rounded-xl border border-dashed border-border bg-secondary/30 p-4">
              <h3 className="font-display text-lg font-bold text-navy">On the roadmap</h3>
              <ul className="mt-4 space-y-2">
                {plannedFeatures.map((feature) => (
                  <li key={feature.id} className="text-sm text-muted-foreground">
                    <span className="mr-2 rounded bg-secondary px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-slate">
                      Planned
                    </span>
                    <span className="font-medium text-navy">{feature.name}</span>
                    {' — '}
                    {feature.description}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ) : null}

        <p className="mt-5 max-w-3xl text-sm leading-relaxed text-muted-foreground">
          AeroJudge is designed for FAI-style Paragliding Accuracy competition workflows, with scoring
          profiles based on supported FAI Sporting Code rules. It is independently developed by Nepalabs
          and is not presented as official FAI software or FAI-certified.
        </p>
      </div>
    </section>
  );
}
